import {
    useCallback,
} from 'react'
import {
    ActionLinkFunction,
} from 'app/types/form.types'

export default function useActionLinkFunction<Value>({
    actionLinkFunction,
    value,
}: {
    actionLinkFunction: ActionLinkFunction<Value>,
    value: Value
}) {
    return useCallback(() => {
        return actionLinkFunction?.(value)
    }, [
        actionLinkFunction,
        value,
    ])
}
